import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    breadCrumbLinks: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline !important'
      }
    },
    annexedContractsDataTable: {
      margin: '0 auto',
      width: '100%'
    }
  })
